let RECEIPT_BILL_ONE_PERSON_SHOULD_PAY = '一人当たり';
let RECEIPT_BILL_SUBTOTAL = '合計';
let RECEIPT_BILL_SPLITTING = '割り勘する';
let TAX = '（サービス料 + 消費税）';

export default { RECEIPT_BILL_ONE_PERSON_SHOULD_PAY, RECEIPT_BILL_SUBTOTAL, RECEIPT_BILL_SPLITTING, TAX };
